import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import MaterialTable from 'material-table'
import { tableIcons } from '../../../class/utils'

import { Label, PrimaryButton } from '../../default'
import { BlockModal } from '../../modal'

function TableBlock({ classes, customers }) {
  const { t } = useTranslation()
  const [enableModal, setEnableModal] = useState(false)
  const [currentCustomer, setCurrentCustomer] = useState(null)


  const _getBlockedStyle = status => {
    if (status) {
      return {
        backgroundColor: '#4caf50',
        fontWeight: 'bold',
      };
    }
    else {
      return {
        fontWeight: 'bold'
      };
    }
  }

  const openBlockModal = (customer) => {
    setCurrentCustomer({
      id: customer.customer_id,
      fullName: customer.full_name,
      email: customer.email,
      isBlocked: customer.is_blocked
    })
    setEnableModal(true)
  }

  const prepareColumns = () => {
    return [
      { title: t('panels.block.table.columns.id'), field: 'customer_id' },
      { title: t('panels.block.table.columns.full_name'), field: 'full_name' },
      { title: t('panels.block.table.columns.email'), field: 'email' },
      { title: t('panels.block.table.columns.phone'), field: 'phone' },
      { title: t('panels.block.table.columns.last_login'), field: 'last_login' },
      { title: t('panels.block.table.columns.cnpj'), field: 'cnpj' },
      {
        title: t('panels.block.table.columns.is_blocked'),
        field: 'is_blocked',
        render: rowData => (
          <PrimaryButton onClick={() => openBlockModal(rowData)} style={_getBlockedStyle(rowData.is_blocked)}>
            {rowData.is_blocked ? "Desbloquear" : "Bloquear"}
          </PrimaryButton>
        )
      }
    ]
  }

  const prepareData = () => {
    if (!customers) {
      return [];
    }

    return customers.map(customer => {
      return {
        customer_id: customer.customer_id,
        full_name: `${customer.first_name} ${customer.last_name}`,
        email: customer.customerContact ? customer.customerContact.email : "Indefinido",
        phone: customer.customerContact ? customer.customerContact.phone_1 : "Indefinido",
        last_login: customer.last_login ? customer.last_login.split("T").join(" ").split(".").slice(0, 1).join(" ") : "Indefinido",
        cnpj: customer.customerCompany ? customer.customerCompany.cnpj : "Indefinido",
        is_blocked: customer.is_blocked
      }
    });
  }

  const toggleBlocked = () => {
    // eslint-disable-next-line
    let index = customers.findIndex(customer => customer.customer_id == currentCustomer.id);
    customers[index].is_blocked = !customers[index].is_blocked;
    setEnableModal(false);
    setCurrentCustomer(null);
  }

  return (
    <>
      <BlockModal
        onRefresh={toggleBlocked}
        onClose={() => setEnableModal(false)}
        open={enableModal}
        currentCustomer={currentCustomer} />
      <MaterialTable
        icons={tableIcons}
        data={prepareData()}
        columns={prepareColumns()}
        options={{
          search: false,
          headerStyle: {
            fontWeight: 'bold'
          }
        }}
        localization={t('materialTableLocale', { returnObjects: true })}
        components={{
          Toolbar: () => (
            <div style={{ padding: '16px' }}>
              <Label v='h6' bold>{t('panels.block.table.title')}</Label>
            </div>
          )
        }}
      />
    </>
  )
}

TableBlock.propTypes = {
  customers: PropTypes.array,
}

TableBlock.defaultProps = {
  customers: []
}

const styles = theme => ({

})

export default withStyles(styles)(TableBlock)